<template>
  <page>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
        <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
        <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
        <v-toolbar-title v-if="tranMode === 'New'">New Retention Type</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Review'">Edit Retention Type</v-toolbar-title>
        <v-toolbar-title v-if="tranMode === 'Query'">View Existing Retention Type</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <!-- <message :messages="messages"></message> -->
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg4 md4 xs12>
              <v-autocomplete
                :items="acctTypeList"
                :label="labels.riType"
                v-model="form.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="labels.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'entry'"
              ></v-autocomplete>
            </v-flex>
            <v-flex xl3 lg4 xs4>
              <v-text-field
                v-model="form.rtnType"
                :label="labels.rtnType"
                :error-messages="errors.collect('form.rtnType')"
                data-vv-name="form.rtnType"
                :data-vv-as="labels.rtnType"
                v-validate="'required'"
              ></v-text-field>
            </v-flex>
            <v-flex xl3 lg4 xs4>
              <v-text-field
                v-model="form.rtnTypeDesc"
                :label="labels.rtnTypeDesc"
                :error-messages="errors.collect('form.rtnTypeDesc')"
                data-vv-name="form.rtnTypeDesc"
                :data-vv-as="labels.rtnTypeDesc"
                v-validate="'required'"
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs6>
              <v-autocomplete :items="rtnStmtLnTypeList" :label="labels.rtnStmtLnType" v-model="form.rtnStmtLnType" item-text="label" item-value="value" :error-messages="errors.collect('form.rtnStmtLnType')" data-vv-name="form.rtnStmtLnType" :data-vv-as="labels.rtnStmtLnType" v-validate="'entry'" clearable>
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                  <v-icon color="info" @click="getHelpList('stmtLnTypeRtn')" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="relStmtLnTypeList" :label="labels.relStmtLnType" v-model="form.relStmtLnType" item-text="label" item-value="value" :error-messages="errors.collect('form.relStmtLnType')" data-vv-name="form.relStmtLnType" :data-vv-as="labels.relStmtLnType" v-validate="'entry'" clearable>
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                  <v-icon color="info" @click="getHelpList('stmtLnTypeRel')" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-flex> -->
            <v-flex xs6>
              <v-text-field
                v-model="form.rtnStmtLnType"
                :label="labels.rtnStmtLnType"
                :error-messages="errors.collect('rtnStmtLnType')"
                data-vv-name="rtnStmtLnType"
                :data-vv-as="labels.rtnStmtLnType"
                append-icon="mdi-magnify"
                @click:append="getHelpList('stmtLnTypeRtn')"
                v-validate="checkStmtLnTypeRtn"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                v-model="form.relStmtLnType"
                :label="labels.relStmtLnType"
                :error-messages="errors.collect('relStmtLnType')"
                data-vv-name="relStmtLnType"
                :data-vv-as="labels.relStmtLnType"
                append-icon="mdi-magnify"
                @click:append="getHelpList('stmtLnTypeRel')"
                v-validate="checkStmtLnTypeRel"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ form.createdBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ form.createdDate | formatDate }}</div>
            </v-flex>
          </v-layout>
          <v-layout wrap v-if="!newMode">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              <div class="queryValue">{{ form.modifiedBy }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              <div class="queryValue">{{ form.modifiedDate | formatDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
        Save
        <v-icon right>mdi-content-save </v-icon>
      </v-btn>
    </v-card>
    <v-dialog v-model="helplist" width="900px" persistent>
      <!-- Helplist component -->
      <stmtLnType-help-list v-if="stmtLnTypeRtnHelplist" @close="doClose" @selectStmtLnType="doAssign($event)"></stmtLnType-help-list>
      <stmtLnTypeRel-help-list v-if="stmtLnTypeRelHelplist" @close="doClose" @selectStmtLnTypeRel="doAssign($event)"></stmtLnTypeRel-help-list>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { acctType } from '@/const/params'
import StmtLnTypeHelplist from './helplist/StmtLnTypeHelplist.vue'
import StmtLnTypeRelHelplist from './helplist/StmtLnTypeRelHelplist.vue'

export default {
  data() {
    return {
      newMode: true,
      reviewMode: false,
      queryMode: false,
      submitting: false,
      rtnStmtLnTypeList: [],
      relStmtLnTypeList: [],
      helplist: false,
      stmtLnTypeRtnHelplist: false,
      stmtLnTypeRelHelplist: false,
      labels: {
        newButton: 'New Retention Type',
        riType: 'Inwards / Outwards',
        rtnType: 'Retention Type',
        rtnTypeDesc: 'Retention Type Description',
        rtnStmtLnType: 'Statement Line Type - Retention',
        relStmtLnType: 'Statement Line Type - Release',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      filters: {
        rtnType: null,
        rtnTypeDesc: null
      },
      form: {
        riType: 'O',
        rtnType: undefined,
        rtnTypeDesc: undefined,
        rtnStmtLnType: undefined,
        relStmtLnType: undefined,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null
      }
    }
  },
  methods: {
    async doFetchData() {
      const apiURI = this.menu.getRtnType
      if (apiURI) {
        this.submitting = true
        try {
          const expand = {
            riType: this.rtnType.riType,
            rtnType: this.rtnType.rtnType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.riType = data.rtnType.riType
            this.form.rtnType = data.rtnType.rtnType
            this.form.rtnTypeDesc = data.rtnType.rtnTypeDesc
            this.form.rtnStmtLnType = data.rtnType.rtnStmtLnType
            this.form.relStmtLnType = data.rtnType.relStmtLnType
            this.form.createdBy = data.rtnType.createdBy
            this.form.createdDate = data.rtnType.createdDate
            this.form.modifiedBy = data.rtnType.modifiedBy
            this.form.modifiedDate = data.rtnType.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    doCancel() {
      this.$router.push({ name: 'rtnType' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createRtnType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'rtnType' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateRtnType
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'rtnType' })
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'stmtLnTypeRtn') {
        this.stmtLnTypeRtnHelplist = true
      } else if (fieldname === 'stmtLnTypeRel') {
        this.stmtLnTypeRelHelplist = true
      }
    },
    doClose() {
      this.resetMessages()
      this.helplist = false
      setTimeout(() => {
        this.stmtLnTypeRtnHelplist = false
        this.stmtLnTypeRelHelplist = false
      }, 500)
    },
    doAssign(stmtLnType) {
      if (stmtLnType.stmtLnTypeRtnRel === 'stmtLnTypeRtn') {
        this.form.rtnStmtLnType = stmtLnType.stmtLnType
      } else if (stmtLnType.stmtLnTypeRtnRel === 'stmtLnTypeRel') {
        this.form.relStmtLnType = stmtLnType.stmtLnType
      }
    }
  },
  computed: {
    rtnType() {
      return this.$route.params.rtnType
    },
    tranMode() {
      return this.$route.params.tranMode
    },
    menu() {
      return this.$store.state.rtnType.menu
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    checkStmtLnTypeRtn() {
      const result = 'required|rtnStmtLnTypeCheck:' + this.form.relStmtLnType
      return result
    },
    checkStmtLnTypeRel() {
      const result = 'required|relStmtLnTypeCheck:' + this.form.rtnStmtLnType
      return result
    }
  },
  created() {
    if (this.rtnType === undefined && this.tranMode === undefined) {
      this.$router.push({ name: 'rtnType' })
    }
    if (this.rtnType === 'new') {
      this.newMode = true
      this.reviewMode = false
      this.queryMode = false
      this.form.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.form.createdDate = new Date()
    } else if (this.tranMode === 'Review') {
      this.newMode = false
      this.reviewMode = true
      this.queryMode = false
      this.doFetchData()
    } else if (this.tranMode === 'Query') {
      this.newMode = false
      this.reviewMode = false
      this.queryMode = true
      this.doFetchData()
    }
    this.$validator.extend('rtnStmtLnTypeCheck', {
      getMessage(field, args) {
        return `${field} cannot equal Statement Line Type - Release`
      },
      validate(value, args) {
        if (value) {
          var relStmtLnType = args[0]
          if (value === relStmtLnType) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })
    this.$validator.extend('relStmtLnTypeCheck', {
      getMessage(field, args) {
        return `${field} cannot equal Statement Line Type - Retention`
      },
      validate(value, args) {
        if (value) {
          var rtnStmtLnType = args[0]
          if (value === rtnStmtLnType) {
            return false
          } else {
            return true
          }
        } else {
          return true
        }
      }
    })
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  components: {
    'stmtLnType-help-list': StmtLnTypeHelplist,
    'stmtLnTypeRel-help-list': StmtLnTypeRelHelplist
  }
}
</script>
